import { call, put, takeLatest } from 'redux-saga/effects';

import { imageUpdateError, imageUpdateRequest, imageUpdateStore } from './imageActions.js';
import { updateImageApiCall } from './imageAPI.js';

function* updateImageSaga({ payload }) {
  try {
    yield call(updateImageApiCall, payload);
    yield put(imageUpdateStore());
  } catch (error) {
    yield put(imageUpdateError(error.Message ? error.Message : error.toString()));
  }
}

export function* emailsImageWatcher() {
  yield takeLatest(imageUpdateRequest.type, updateImageSaga);
}
